export default {
  ALL: "alle",
  RELEVANT: "aktuelle",
  NONE: "keine",
  LINK: "link",
};
